// import { FiArrowLeft } from 'react-icons/fi'
// import { Link } from 'react-router-dom'
// import { assets } from '../../../data/assests'
// const Header = () => {
//     return (
//         <section style={
//             {
//                 backgroundImage: `url("${assets.header_image_1}")`
//                 , backgroundSize: '100% 100%'
//                 , backgroundRepeat: 'no-repeat'
//                 , backgroundAttachment: 'fixed'
//             }
//         } className="home-header text-white py-20">
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//                 <div className="text-center">
//                     <h1 className="text-4xl md:text-6xl font-bold mb-6">
//                         أهلا  في  حَكّمني
//                     </h1>
//                     <p className="text-xl md:text-2xl mb-8 opacity-90">
//                         منصتك للتعلم مع أفضل المعلمين في حمص
//                     </p>
//                     <div className="flex flex-col sm:flex-row gap-4 justify-center">
//                         <Link
//                             to="/login"
//                             className="border-2 border-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-black transition-colors inline-flex items-center justify-center space-x-2 space-x-reverse"
//                         >
//                             <span>تسجيل الدخول</span>
//                             <FiArrowLeft className="w-5 h-5" />
//                         </Link>
//                         <Link
//                             to="/register"
//                             className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-black transition-colors inline-flex items-center justify-center"
//                         >
//                             إنشاء حساب جديد
//                         </Link>
//                     </div>
//                 </div>
//             </div>
//         </section>
//     )
// }

// export default Header




import { FiArrowLeft } from "react-icons/fi";
import { Stethoscope, HeartPulse, Syringe, User, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const Header = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    // فحص وجود التوكن في localStorage
    const userToken = localStorage.getItem("userToken");
    const teacherToken = localStorage.getItem("teacherToken");
    const adminToken = localStorage.getItem("adminToken");
    
    if (userToken) {
      setIsAuthenticated(true);
      setUserType('student');
    } else if (teacherToken) {
      setIsAuthenticated(true);
      setUserType('teacher');
    } else if (adminToken) {
      setIsAuthenticated(true);
      setUserType('admin');
    } else {
      setIsAuthenticated(false);
      setUserType(null);
    }
  }, []);

  return (
    <section
      className="home-header text-white py-20 relative
                 bg-gradient-to-br from-blue-900 via-cyan-800 to-green-600"
    >
      {/* أيقونات خلفية طبية متحركة */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/5 animate-float text-blue-200 opacity-30 text-6xl">
          <Stethoscope />
        </div>
        <div className="absolute top-3/4 left-1/4 animate-float-delayed text-green-300 opacity-30 text-5xl">
          <HeartPulse />
        </div>
        <div className="absolute top-1/3 right-1/5 animate-float-slow text-cyan-300 opacity-30 text-6xl">
          <Syringe />
        </div>
      </div>

      {/* النصوص */}

<div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
  <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-snug">
    أهلا بك في{" "}
    <span className="block md:inline text-green-300">حَكّمني</span>
  </h1>

  <p className="text-xl md:text-2xl mb-8 opacity-90">
    منصتك لحجز موعدك الطبي بسهولة مع أفضل الأطباء في سوريا
  </p>


    

        {/* الأزرار */}
        <div className="flex flex-col sm:flex-row gap-6 justify-center">
          {!isAuthenticated ? (
            // عرض أزرار تسجيل الدخول وإنشاء الحساب للمستخدمين غير المسجلين
            <>
              <Link
                to="/login"
                className="bg-white text-blue-900 px-10 py-4 rounded-lg font-semibold 
                           shadow-lg hover:bg-blue-100 transition-colors inline-flex 
                           items-center justify-center"
              >
                <span>تسجيل الدخول</span>
              </Link>
              <Link
                to="/register"
                className="bg-green-600 text-white px-10 py-4 rounded-lg font-semibold 
                           shadow-lg hover:bg-green-700 transition-colors inline-flex 
                           items-center justify-center"
              >
                إنشاء حساب جديد
              </Link>
            </>
          ) : (
            // عرض أزرار مختلفة حسب نوع المستخدم
            <>
              {userType === 'student' && (
                <>
                  <Link
                    to="/doctors"
                    className="bg-white text-blue-900 px-10 py-4 rounded-lg font-semibold 
                               shadow-lg hover:bg-blue-100 transition-colors inline-flex 
                               items-center justify-center gap-2"
                  >
                    <Users className="w-5 h-5" />
                    <span>الأطباء</span>
                  </Link>
                  <Link
                    to="/profile"
                    className="bg-green-600 text-white px-10 py-4 rounded-lg font-semibold 
                               shadow-lg hover:bg-green-700 transition-colors inline-flex 
                               items-center justify-center gap-2"
                  >
                    <User className="w-5 h-5" />
                    <span>الملف الشخصي</span>
                  </Link>
                </>
              )}
              
              {userType === 'teacher' && (
                <>
                  <Link
                    to="/doctor/dashboard"
                    className="bg-white text-blue-900 px-10 py-4 rounded-lg font-semibold 
                               shadow-lg hover:bg-blue-100 transition-colors inline-flex 
                               items-center justify-center gap-2"
                  >
                    <Stethoscope className="w-5 h-5" />
                    <span>لوحة التحكم</span>
                  </Link>
                  <Link
                    to="/doctor/profile"
                    className="bg-green-600 text-white px-10 py-4 rounded-lg font-semibold 
                               shadow-lg hover:bg-green-700 transition-colors inline-flex 
                               items-center justify-center gap-2"
                  >
                    <User className="w-5 h-5" />
                    <span>الملف الشخصي</span>
                  </Link>
                </>
              )}

              {userType === 'admin' && (
                <>
                  <Link
                    to="/admin/dashboard"
                    className="bg-white text-blue-900 px-10 py-4 rounded-lg font-semibold 
                               shadow-lg hover:bg-blue-100 transition-colors inline-flex 
                               items-center justify-center gap-2"
                  >
                    <Users className="w-5 h-5" />
                    <span>لوحة الإدارة</span>
                  </Link>
                  <Link
                    to="/admin/patients"
                    className="bg-green-600 text-white px-10 py-4 rounded-lg font-semibold 
                               shadow-lg hover:bg-green-700 transition-colors inline-flex 
                               items-center justify-center gap-2"
                  >
                    <User className="w-5 h-5" />
                    <span>المرضى</span>
                  </Link>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
};

export default Header;


// import { FiArrowLeft } from "react-icons/fi";
// import { Stethoscope, HeartPulse, Syringe } from "lucide-react";
// import { Link } from "react-router-dom";

// const Header = () => {
//   return (
//     <section
//       className="home-header text-white py-20 relative
//                  bg-gradient-to-br from-blue-900 via-cyan-800 to-green-600"
//     >
//       {/* أيقونات خلفية طبية متحركة */}
//       <div className="absolute inset-0 overflow-hidden pointer-events-none">
//         <div className="absolute top-1/4 left-1/5 animate-float text-blue-200 opacity-30 text-6xl">
//           <Stethoscope />
//         </div>
//         <div className="absolute top-3/4 left-1/4 animate-float-delayed text-green-300 opacity-30 text-5xl">
//           <HeartPulse />
//         </div>
//         <div className="absolute top-1/3 right-1/5 animate-float-slow text-cyan-300 opacity-30 text-6xl">
//           <Syringe />
//         </div>
//       </div>

//       {/* النصوص */}
//       <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
//         <h1 className="text-5xl md:text-7xl font-bold mb-6">
//           أهلا بك في <span className="text-green-300">حَكّمني</span>
//         </h1>
//         <p className="text-xl md:text-2xl mb-8 opacity-90">
//           منصتك لحجز موعدك الطبي بسهولة مع أفضل الأطباء في حمص
//         </p>

//         {/* الأزرار */}
//         <div className="flex flex-col sm:flex-row gap-6 justify-center">
//           <Link
//             to="/login"
//             className="bg-white text-blue-900 px-10 py-4 rounded-lg font-semibold 
//                        shadow-lg hover:bg-blue-100 transition-colors inline-flex 
//                        items-center justify-center"
//           >
//             <span>تسجيل الدخول</span>
//           </Link>
//           <Link
//             to="/register"
//             className="bg-green-600 text-white px-10 py-4 rounded-lg font-semibold 
//                        shadow-lg hover:bg-green-700 transition-colors inline-flex 
//                        items-center justify-center"
//           >
//             إنشاء حساب جديد
//           </Link>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Header;

